var default_1 = /** @class */ (function () {
    function default_1(component, stateKey) {
        var _a;
        if (stateKey === void 0) { stateKey = "loaded"; }
        this.component = component;
        this.stateKey = stateKey;
        this.isMounted = true;
        var loaded = this.__load(this.component.props.load);
        this.component.setState((_a = {}, _a[this.stateKey] = loaded, _a));
    }
    default_1.prototype.update = function (nextProps) {
        var _a;
        if (nextProps.load !== this.component.props.load) {
            var loaded = this.__load(nextProps.load);
            this.component.setState((_a = {}, _a[this.stateKey] = loaded, _a));
        }
    };
    default_1.prototype.destroy = function () {
        this.isMounted = false;
    };
    default_1.prototype.__isLoaded = function (promise) {
        var isPromise = promise && "then" in promise;
        return isPromise;
    };
    default_1.prototype.__load = function (load) {
        var _this = this;
        var loaded = true;
        if (this.__isLoaded(load)) {
            loaded = false;
            load
                .catch(function () {
                return true;
            })
                .then(function () {
                var _a;
                if (_this.isMounted) {
                    _this.component.setState((_a = {}, _a[_this.stateKey] = true, _a));
                }
            });
        }
        return loaded;
    };
    return default_1;
}());
export default default_1;
